import * as Yup from 'yup';
import { PqrStrategicAlly } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrStrategicAlly & { strategicAllyLabel?: string } =
    {
        strategicAlly: '',
        strategicAllyLabel: '',
    };

export const validationSchema = Yup.object({
    strategicAlly: Yup.string().required(
        'El aliado estratégico es obligatorio'
    ),
});
